import React, { useState, useEffect } from 'react';
import { Badge, Button, Tooltip } from 'antd';

import { useNavigate, useParams } from 'react-router-dom';
import { DropdownMobile, errorCatch, GET, JSXMap, updateInArray, useAuth, useTranslateContext } from 'fennec-ui';
import { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { PrinterOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import { getIndexColor, getIndexColorAlt, getIndexColorLighter } from '../../../../common/Tool';
import dayjs from 'dayjs';
import { useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../../common/Context';
import { Checkbox, Collapse } from 'antd-mobile';
import Markdown from 'markdown-to-jsx';
import { ContextTestingAdminElement } from '../../../components/ContextElement';
import badgeCheckIcon from '../../../../icons/badge.png' // relative path to image 

export default function ReportTestiSudeiskikhAttestatsii(props) {
	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
	const isMobile = useIsMobileContext();
	const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

	let navigate = useNavigate();

	const { auth } = props;
	const { id } = useParams();
	const t = useTranslateContext();
	const [loading, setLoading] = useState(false);

	const [result, setResult] = useState()

	useEffect(() => {
		setLoading(true);

		GET(auth, `/api/testisudeiskikhattestatsii/result-for-admin/${id}`, ({ data }) => {
			setResult(data)
			setLoading(false);
		}, (err) => errorCatch(err, () => setLoading(false)));

	}, [auth]);

	const ref = useRef(null)

	const display = (item) => (<div style={{ width: "100%" }}><div key={item?.ID} className='element bg bg-fwhite' style={{ textAlign: "left", padding: "3px 0" }}>
		<div className='element-wrapper'>
			<div className='element-content'>
				<div className='element-content-body'>
					{item?.sudya.user.lastname} {item?.sudya.user.firstname} ({item?.sudya?.regionalnoeOtdelenie?.nazvanie})
				</div>
				<div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
					<div>
						Категория судейства: {item?.kategoriyaSudeistva?.nazvanieKategorii + " - " + item?.kategoriyaSudeistva?.tanets.nazvanie}
					</div>
					<div>
						Шаблон теста: {item?.shablon?.nazvanie}
					</div>
				</div>
			</div>

			<div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
				<div>
					<div>
						{item?.CreatedAt && <div>Дата создания: {dayjs(item?.CreatedAt).format("DD.MM.YYYY HH:mm")} {(item?.done) ? "(завершен)" : "(не завершен)"}</div>}
					</div>
					{item?.done && <div style={{ color: (item?.nabranniiProtsent >= item?.prokhodnoiProtsent) ? "green" : "red" }}>
						Тест {(item?.nabranniiProtsent >= item?.prokhodnoiProtsent) ? "пройден!" : "не пройден."}
					</div>}
				</div>
			</div>
		</div>
	</div></div>)

	const declOfNum = (number, titles) => {
		let cases = [2, 0, 1, 1, 1, 2];
		return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
	}

	return (
		<div>
			<div style={{ display: "flex", justifyContent: "right", padding: "15px 20px" }} >
				<ReactToPrint
					trigger={() => {
						// NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
						// to the root node of the returned component as it will be overwritten.
						return (<Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }}><PrinterOutlined /> Печать</Button>)
					}}
					content={() => ref.current}
				/>
			</div>
			{(!!result?.test?.ID) && <div className="report" style={{ padding: "0 25px", maxWidth: "900px", margin: "0 auto" }} ref={ref}>

				<div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", fontWeight: "bold", fontSize: "20px", marginBottom: "20px" }}>
					<div key={result.test.ID} style={{ width: "100%", display: "flex", gap: "5px" }}>
						<div style={{ flex: "1 1 auto" }}>
							{(display) ? display(result.test) : (
								<div style={{ padding: "0px 5px" }}>
									{/* <div>
                                            <a href={`${result.test.ID}`}>{getObjectDisplay(result.test, "TestiSudeiskikhAttestatsii", meta)}</a>
                                        </div>
                                        <div style={{ color: "#6a6a6a" }}></div> */}
								</div>
							)}
						</div>
					</div>
				</div>

				<div>
					<div className="bg bg-grey border-grey" style={{ marginBottom: "15px" }}>
						<div style={{ textAlign: "center" }}>
							{(result?.nabranniiProtsent >= result?.test?.prokhodnoiProtsent) && <div style={{ textAlign: "center" }}>
								<img src={badgeCheckIcon} style={{ width: "125px" }} />
							</div>}
							<div style={{ fontSize: "18px" }}>
								<div>Ваш результат</div>
								<div style={{ color: (result?.nabranniiProtsent >= result?.test?.prokhodnoiProtsent) ? "green" : "red", fontSize: "26px" }}>{result?.nabranniiProtsent}%</div>
							</div>
							<div style={{ fontSize: "12px", fontWeight: "300", paddingBottom: "15px" }}>Для прохождения необходимо {result?.test?.prokhodnoiProtsent}%</div>
						</div>

						<div style={{ textAlign: "center" }}>
							<div><i className="fa fa-circle" style={{ color: "#cbcbcb" }}></i> Набрано баллов: <span style={{ fontWeight: "bold" }}>{result?.summaBallov} из {result?.vsegoBallovVTeste}</span></div>
							<div><i className="fa fa-check-circle-o" style={{ color: "green" }}></i> Правильных ответов: {result?.pravilnoOtvechennieVoprosi}</div>
							<div><i className="fa fa-times-circle-o" style={{ color: "red" }}></i> Неправильных ответов: {result?.nePravilnoOtvechennieVoprosi}</div>
						</div>
					</div>

					{JSXMap(result.test?.testVoprosiSudeiskikhAttestatsiiTest, (e, idx) => {
						let check = e?.testVariantiOtvetovVopros?.find(a => a?.selected)
						let res = result?.voprosi?.find(r => r?.vopros?.ID === e?.ID)
						let incorrect = false;
						if (res) {
							incorrect = !res.pravilnoOtvechen
						}

						return (<div key={e?.ID} style={{ marginBottom: "15px" }}>
							<div style={{ lineHeight: "16px" }}>

								<div style={{ fontSize: "14px", fontWeight: "bold" }}>Вопрос {idx + 1}</div>
								<div style={{ fontSize: "11px", color: "grey", display: "flex", justifyContent: "space-between", gap: "3px" }}>
									<div style={{ flex: "0 0" }}><Badge color={(!res) ? (check) ? 'orange' : '#d5d5d5' : (incorrect) ? 'red' : '#87d068'} style={{
										minWidth: "8px",
										width: "8px",
										height: "8px"
									}}></Badge></div>
									<div style={{ flex: "1 1 auto", textAlign: "left" }}>{e?.tsennostVoprosa} {declOfNum(e?.tsennostVoprosa, ['балл', 'балла', 'баллов'])}</div>
								</div>
							</div>
							<div className='question' style={{ marginLeft: "2px", borderLeft: `1px solid ${(!res) ? (check) ? 'orange' : '#d5d5d5' : (incorrect) ? 'red' : '#87d068'}`, padding: "5px 10px", display: "flex", flexDirection: "column" }}>

								<div style={{ fontSize: "14px" }}>
									<Markdown className="md">{e?.tekstVoprosa}</Markdown>
								</div>
								<div style={{ fontSize: "12px", color: "grey", marginTop: "15px" }}>Варианты ответов:</div>
								<div className='answers' style={{ fontSize: "14px" }}>
									{JSXMap(e?.testVariantiOtvetovVopros, (a, aidx) => (
										<div key={a?.ID} className={`bg ${(a?.flag) ? "border-darkblue" : (a?.selected) ? "border-grey" : "border-grey"}`} style={{
											textAlign: "left",
											marginBottom: "5px"
										}}>
											<Checkbox
												style={{ width: "100%", "--icon-size": "16px", "--font-size": "14px" }}
												disabled={loading}
												checked={a?.selected}
											>
												<Markdown className="md">{a?.tekst}</Markdown>
											</Checkbox>
										</div>
									))}
								</div>
								{(e?.kommentarii) && <div style={{ marginTop: "15px" }}>
									<div style={{ fontSize: "12px", color: "grey" }}>Комментарий:</div>
									<div>
										{e?.kommentarii}
									</div>
								</div>}
							</div>
						</div>)
					})}
				</div>
			</div>}
		</div >);

}
